'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var es = {};

exports.__exports = es;
